import styled from "styled-components";

export const StyledNoOfRatings = styled.div`
  font-size: 12px;
  color: #666;
  position: relative;
  top: 2px;
`;

export const StyledRatingComment = styled.div`
  border-bottom: solid 1px #efefef;
  margin-bottom: 10px;
  padding-bottom: 10px;
`;

export const StyledRatingName = styled.div`
  font-weight: bold;
`;
